import { find, isNull } from 'lodash';
import {
  createOncoCareDraft,
  updateOncoCareDraft,
  getOncoCareDraftContractByTokenRequest,
  saveOncoCareContractInCacheRequest,
} from '../../api/oncoCareApi';
import { mapErrorsToContractSteps } from '../../helpers/oncoCare/oncoCareContractHelpers';
import { setSaveCard } from './payment';
import {
  oncoCareCalculationReducerForContract,
  SET_MOBILE_CONTRACT_DATA,
  SET_MOBILE_CONTRACT_DATA_FAIL,
  SET_MOBILE_CONTRACT_DATA_SUCCESS,
} from './oncoCareCalculation';
import { MONTHLY, PAYMENT_FREQUENCIES } from '../../constants/paymentFrequency';
import { ACTION_NAME } from '../../constants';
import { fetchMobileContractDataRequest } from '../../api/contractApi';
import { bindMobileContractUserData } from '../../helpers/contractHelpers';
import { ONCOCARE_GET_MOBILE_CONTRACT_PREFIX } from '../../constants/oncoCare';
import { bindOncoCareContractCalculationData } from '../../helpers/oncoCare/bindData';

const SET_SIGNER = 'efes/oncoCareContract/SET_SIGNER';
const SET_HAS_ADD_SIGNER = 'efes/oncoCareContract/SET_HAS_ADD_SIGNER';

const ADD_INSURED_PERSON = 'efes/oncoCareContract/ADD_INSURED_PERSON';
const SAVE_INSURED_PERSON = 'efes/oncoCareContract/SAVE_INSURED_PERSON';
const REMOVE_INSURED_PERSON = 'efes/oncoCareContract/REMOVE_INSURED_PERSON';

const SET_ONCO_CARE_DETAILS = 'efes/oncoCareContract/SET_ONCO_CARE_DETAILS';

const SET_PAYMENT_METHOD = 'efes/oncoCareContract/SET_PAYMENT_METHOD';
const SET_HAS_AGREED = 'efes/oncoCareContract/SET_HAS_AGREED';
const SET_HAS_AGREED_AUTOMATIC_RECURRING = 'efes/oncoCareContract/SET_HAS_AGREED_AUTOMATIC_RECURRING';

const SAVE_DRAFT_CONTRACT = 'efes/oncoCareContract/SAVE_DRAFT_CONTRACT';
const SAVE_DRAFT_CONTRACT_SUCCESS = 'efes/oncoCareContract/SAVE_DRAFT_CONTRACT_SUCCESS';
const SAVE_DRAFT_CONTRACT_FAIL = 'efes/oncoCareContract/SAVE_DRAFT_CONTRACT_FAIL';

const SAVE_ONCO_CARE_CONTRACT_IN_CACHE = 'efes/oncoCareContract/SAVE_ONCO_CARE_CONTRACT_IN_CACHE';
const SAVE_ONCO_CARE_CONTRACT_IN_CACHE_SUCCESS = 'efes/oncoCareContract/SAVE_ONCO_CARE_CONTRACT_IN_CACHE_SUCCESS';
const SAVE_ONCO_CARE_CONTRACT_IN_CACHE_FAIL = 'efes/oncoCareContract/SAVE_ONCO_CARE_CONTRACT_IN_CACHE_FAIL';

const GET_DRAFT_ONCO_CARE_CONTRACT = 'efes/oncoCareContract/GET_DRAFT_ONCO_CARE_CONTRACT';
const GET_DRAFT_ONCO_CARE_CONTRACT_SUCCESS = 'efes/oncoCareContract/GET_DRAFT_ONCO_CARE_CONTRACT_SUCCESS';
const GET_DRAFT_ONCO_CARE_CONTRACT_FAIL = 'efes/oncoCareContract/GET_DRAFT_ONCO_CARE_CONTRACT_FAIL';

const CLEAR_ONCO_CARE_CONTRACT = 'efes/oncoCareContract/CLEAR_ONCO_CARE_CONTRACT';

const CLEAR_SIGNER_ERRORS = 'efes/oncoCareContract/CLEAR_SIGNER_ERRORS';
const REMOVE_INSURED_PERSON_ERRORS = 'efes/oncoCareContract/REMOVE_INSURED_PERSON_ERRORS';
const CLEAR_CALCULATOR_ERRORS = 'efes/oncoCareContract/CLEAR_CALCULATOR_ERRORS';

const SET_MOBILE_TOKEN = 'efes/oncoCareContract/SET_MOBILE_TOKEN';

const initialState = {
  contractData: {
    draftId: '',
    hasAddedSigner: true,
    hasAgreedAutomaticRecurring: false,
    signer: {},
    insuredPeople: [],
    oncoCareDetails: {
      age: 0,
      withChildren: false,
      prices: {},
      paymentFrequencies: {},
      paymentFrequency: PAYMENT_FREQUENCIES[MONTHLY],
      isFetchingPrice: false,
      fetchPricesError: null,
      oncoCarePriceAmount: null,
      riskAmount: [],
      riskAmounts: [],
      isFetchingRiskAmounts: false,
      fetchRiskAmountsError: null,
      riskLabel: '',
      range: {},
    },
    mobileToken: null,
  },
  hasAgreed: false,
  paymentMethod: '',
  loadingDraftContract: false,
  draftToken: null,
  orderId: null,
  savingContractInCache: false,
  signerBackendErrors: null,
  insuredPersonBackendErrors: null,
  calculatorBackendErrors: null,
};

const saveInsuredPersonReducer = (
  insuredPeople,
  newInsuredPerson,
) => insuredPeople.map((person) => {
  if (person.memberId === newInsuredPerson.memberId) {
    return newInsuredPerson;
  }
  return person;
});

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SIGNER:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          signer: action.data,
        },
      };
    case SET_HAS_ADD_SIGNER:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          hasAddedSigner: action.data,
        },
      };
    case ADD_INSURED_PERSON:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          insuredPeople: [...state.contractData.insuredPeople, action.data],
        },
      };

    case SAVE_INSURED_PERSON:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          insuredPeople: saveInsuredPersonReducer(
            state.contractData.insuredPeople,
            action.data,
          ),
        },
      };
    case REMOVE_INSURED_PERSON:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          insuredPeople: state.contractData.insuredPeople.filter(
            (t) => t.memberId !== action.data.memberId,
          ),
        },
      };
    case SET_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethod: action.data,
      };
    case SET_HAS_AGREED:
      return {
        ...state,
        hasAgreed: action.data,
      };
    case SET_HAS_AGREED_AUTOMATIC_RECURRING:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          hasAgreedAutomaticRecurring: action.data,
        },
      };
    case SAVE_DRAFT_CONTRACT_SUCCESS:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          draftId: action.result,
        },
      };
    case SAVE_ONCO_CARE_CONTRACT_IN_CACHE:
      return {
        ...state,
        draftToken: null,
        orderId: null,
        savingContractInCache: true,
      };
    case SAVE_ONCO_CARE_CONTRACT_IN_CACHE_SUCCESS:
      return {
        ...state,
        draftToken: action.result.draftToken,
        orderId: action.result.id,
        savingContractInCache: false,
      };
    case SAVE_ONCO_CARE_CONTRACT_IN_CACHE_FAIL:
      return {
        ...state,
        draftToken: null,
        orderId: null,
        savingContractInCache: false,
        ...action.backendErrors,
      };
    case SET_ONCO_CARE_DETAILS: {
      return {
        ...state,
        contractData: {
          ...state.contractData,
          oncoCareDetails: { ...state.contractData.oncoCareDetails, ...action.data },
        },
      };
    }
    case GET_DRAFT_ONCO_CARE_CONTRACT:
      return {
        ...state,
        loadingDraftContract: true,
      };
    case GET_DRAFT_ONCO_CARE_CONTRACT_SUCCESS:
      return {
        ...state,
        contractData: { ...state.contractData, ...action.result },
        loadingDraftContract: false,
      };
    case GET_DRAFT_ONCO_CARE_CONTRACT_FAIL:
      return {
        ...state,
        loadingDraftContract: false,
      };

    case CLEAR_SIGNER_ERRORS:
      return {
        ...state,
        signerBackendErrors: null,
      };
    case REMOVE_INSURED_PERSON_ERRORS: {
      const newErrors = { ...state.insuredPersonBackendErrors };
      delete newErrors[action.memberId];
      return {
        ...state,
        insuredPersonBackendErrors: newErrors,
      };
    }
    case CLEAR_CALCULATOR_ERRORS:
      return {
        ...state,
        calculatorBackendErrors: null,
      };
    case CLEAR_ONCO_CARE_CONTRACT:
      return {
        ...initialState,
      };

    case SET_MOBILE_TOKEN:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          mobileToken: action.data,
        },
      };
    default:
      return {
        ...state,
        contractData: {
          ...state.contractData,
          oncoCareDetails: oncoCareCalculationReducerForContract(
            state.contractData.oncoCareDetails,
            action,
          ),
        },
      };
  }
}

export const saveDraftContract = () => (dispatch, getStore) => {
  const { contractData } = getStore().oncoCareContract;
  const { draftId } = contractData;
  return dispatch({
    actions: [
      { type: SAVE_DRAFT_CONTRACT },
      { type: SAVE_DRAFT_CONTRACT_SUCCESS },
      { type: SAVE_DRAFT_CONTRACT_FAIL },
    ],
    promise: draftId
      ? updateOncoCareDraft(contractData)
      : createOncoCareDraft(contractData),
  });
};

export const setSigner = (data) => ({ type: SET_SIGNER, data });

export const setHasAddedSigner = (data) => ({ type: SET_HAS_ADD_SIGNER, data });

export const addInsuredPerson = (data) => ({ type: ADD_INSURED_PERSON, data });

export const saveInsuredPerson = (data) => ({ type: SAVE_INSURED_PERSON, data });

export const removeInsuredPerson = (data) => ({ type: REMOVE_INSURED_PERSON, data });

export const setPaymentMethod = (data) => ({ type: SET_PAYMENT_METHOD, data });

export const setOncoCareDetails = (data) => ({ type: SET_ONCO_CARE_DETAILS, data });

export const setHasAgreed = (data) => ({ type: SET_HAS_AGREED, data });

export const setMobileToken = (data) => ({ type: SET_MOBILE_TOKEN, data });

export const setHasAgreedAutomaticRecurring = (data) => (
  { type: SET_HAS_AGREED_AUTOMATIC_RECURRING, data }
);

export const clearOncoCareContract = () => ({ type: CLEAR_ONCO_CARE_CONTRACT });

export const setOrUpdateSigner = (signerData) => (dispatch, getState) => {
  const { signer, insuredPeople } = getState().oncoCareContract.contractData;
  const isSignerInsured = find(
    insuredPeople,
    ({ memberId }) => memberId === signer.memberId,
  );
  if (isSignerInsured) {
    dispatch(
      saveInsuredPerson({
        ...isSignerInsured,
        ...signerData,
      }),
    );
  }
  dispatch(setSigner(signerData));
};

export const clearSignerBackendErrors = () => ({ type: CLEAR_SIGNER_ERRORS });

export const removeInsuredPersonBackendErrors = (memberId) => ({
  type: REMOVE_INSURED_PERSON_ERRORS,
  memberId,
});

export const clearCalculationBackendErrors = () => ({
  type: CLEAR_CALCULATOR_ERRORS,
});

export const saveOncoCareContractInCache = () => async (dispatch, getStore) => {
  const { contractData } = getStore().oncoCareContract;
  dispatch({ type: SAVE_ONCO_CARE_CONTRACT_IN_CACHE });
  return saveOncoCareContractInCacheRequest(contractData)
    .then((result) => {
      dispatch({ type: SAVE_ONCO_CARE_CONTRACT_IN_CACHE_SUCCESS, result });
      return result;
    })
    .catch((error) => {
      const backendErrors = mapErrorsToContractSteps(
        error.response.data.errors,
        contractData,
      );
      dispatch({
        type: SAVE_ONCO_CARE_CONTRACT_IN_CACHE_FAIL,
        showError: !!(
          isNull(backendErrors.signerBackendErrors) && isNull(backendErrors.calculatorBackendErrors)
        ),
        customMsg: 'contactAgent',
        backendErrors,
      });
      return Promise.reject();
    });
};

export const getDraftOncoCareContractAndSaveInCache = (id, token) => (dispatch) => dispatch({
  actions: [
    { type: GET_DRAFT_ONCO_CARE_CONTRACT },
    { type: GET_DRAFT_ONCO_CARE_CONTRACT_SUCCESS },
    { type: GET_DRAFT_ONCO_CARE_CONTRACT_FAIL },
  ],
  promise: getOncoCareDraftContractByTokenRequest(id, token).then((response) => {
    dispatch(setSaveCard(response.isSave));
    return response;
  }),
}).then(() => dispatch(saveOncoCareContractInCache()));

export const getMobileContractData = (token, prefix) => (dispatch) => {
  dispatch({
    actions: [
      { type: SET_MOBILE_CONTRACT_DATA, name: ACTION_NAME.CALCULATOR },
      { type: SET_MOBILE_CONTRACT_DATA_SUCCESS, name: ACTION_NAME.CALCULATOR },
      {
        type: SET_MOBILE_CONTRACT_DATA_FAIL,
        name: ACTION_NAME.CALCULATOR,
        showError: false,
      },
    ],
    promise: fetchMobileContractDataRequest({ token, prefix }, ONCOCARE_GET_MOBILE_CONTRACT_PREFIX)
      .then(
        (response) => {
          const userDetails = bindMobileContractUserData(
            { ...response.userDetails, email: response.email },
          );
          dispatch(setOrUpdateSigner({ ...userDetails, resident: 1, memberId: 0 }));
          dispatch(setMobileToken(token));
          return bindOncoCareContractCalculationData(response.calculatorDetails);
        },
      ),
  });
};
